import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/15_card_back_island/15_card_back_island"
 * Contains 1 texture(s)
 */
export class CardsBacks15CardBackIslandAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/15_card_back_island/15_card_back_island';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '15_island.png'
    ] as const;
}
